"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageHeader = void 0;

var basic_frontend_common_1 = require("basic-frontend-common");

var react_1 = __importDefault(require("react"));

var react_localization_1 = __importDefault(require("react-localization"));

var components_1 = require("../../../components");

var constants_1 = require("../../../constants");

var json = __importStar(require("./localization.json"));

var PageHeader = function PageHeader(_a) {
  var language = _a.language,
      onLanguageChange = _a.onLanguageChange,
      theme = _a.theme;
  var localizedStrings = new react_localization_1["default"](json);
  localizedStrings.setLanguage(language);
  var title = (0, basic_frontend_common_1.isMobileView)(constants_1.TABLET_VIEW_WIDTH) ? localizedStrings.sharedContent.pages.pageContentAggregateList.title_responsive : localizedStrings.sharedContent.pages.pageContentAggregateList.title;
  var leadText = (0, basic_frontend_common_1.isMobileView)(constants_1.TABLET_VIEW_WIDTH) ? localizedStrings.sharedContent.pages.pageContentAggregateList.leadText_responsive : localizedStrings.sharedContent.pages.pageContentAggregateList.leadText;
  return react_1["default"].createElement(basic_frontend_common_1.IntroComplex, {
    title: title,
    lead: leadText,
    theme: theme,
    component: react_1["default"].createElement(components_1.LanguageSelector, {
      onSelectionChanged: onLanguageChange,
      theme: theme,
      defaultValue: language,
      language: language
    }),
    containerContent: true,
    hruler: true,
    marginBottom: false,
    marginTop: false,
    paddingBottom: false
  });
};

exports.PageHeader = PageHeader;